const uz =  {
  translation: {
    // Navbar
    nav: {
      brand: 'IELTS Speaking AI',
      dashboard: 'Bosh sahifa',
      logout: 'Chiqish',
      admin: 'Admin',
    },
    // Auth
    auth: {
      login: 'Kirish',
      register: "Ro'yxatdan o'tish",
      email: 'Email',
      password: 'Parol',
      name: 'Ism',
      forgotPassword: 'Parolni unutdingizmi?',
      noAccount: "Hisob yo'qmi?",
      hasAccount: 'Hisob bormi?',
      verifyTitle: 'Email tasdiqlash',
      verifyDesc: 'ga 6 xonali kod yuborildi',
      codePlaceholder: '123456',
      confirm: 'Tasdiqlash',
      resendCode: 'Kodni qayta yuborish',
      resetTitle: 'Parolni tiklash',
      resetDesc: 'Emailingizni kiriting, kod yuboramiz',
      newPassword: 'Yangi parol',
      updatePassword: 'Parolni yangilash',
      sendCode: 'Kod yuborish',
      back: '← Orqaga',
      backToLogin: '← Kirish sahifasiga qaytish',
      loggingIn: 'Kirish...',
      registering: "Ro'yxatdan o'tilmoqda...",
      sending: 'Yuborilmoqda...',
      checking: 'Tekshirilmoqda...',
      saving: 'Saqlanmoqda...',
      continue: 'Davom etish',
    },
    // Dashboard
    dashboard: {
      welcome: 'Xush kelibsiz',
      subtitle: 'IELTS Speaking imtihoniga tayyorlanishda davom eting.',
      level: 'Level',
      totalXp: 'Jami XP',
      streak: 'Kunlik streak',
      longestStreak: 'Eng uzun',
      avgScore: "O'rtacha ball",
      sessions: 'sessiya',
      dailyLimit: 'Kunlik limit',
      resetsAt: 'Har kuni 00:00 da yangilanadi',
      remaining: 'ta qoldi',
      used: 'ishlatildi',
      limitDone: 'Tugadi',
      startBtn: 'Boshlash →',
      vocabTitle: 'Topic Vocabulary',
      vocabDesc: "Istalgan topicni kiriting va IELTS speaking uchun kerakli vocabulary so'zlarni oling.",
      speakingTitle: 'Speaking Practice',
      speakingDesc: 'Part 1, 2 yoki 3 ni tanlang. AI bilan real-time suhbat qiling.',
      leaderboard: 'Leaderboard',
      today: 'Bugun',
      week: 'Hafta',
      noLeaderboard: 'Hali hech kim mashq qilmagan',
      recentSessions: "So'nggi sessiyalar",
      noSessions: 'Hali sessiya yo\'q. Birinchi sessiyangizni boshlang!',
      tabHome: '🏠 Bosh sahifa',
      tabProgress: '📈 Progress',
      tabExam: '🎓 Mock Exam',
      youLabel: 'siz',
      premiumUnlimited: 'Premium — Cheksiz imkoniyatlar',
      premiumExpires: 'Premium tugash sanasi',
      daysLeft: 'kun qoldi',
    },
    // Speaking
    speaking: {
      title: 'Speaking Practice',
      subtitle: 'Qaysi part ni mashq qilmoqchisiz?',
      selectTopic: 'Topic tanlang',
      completed: 'tugallangan',
      sessionTitle: 'Speaking Session',
      questions: 'ta savol',
      startBtn: '🚀 Start Practice',
      stopBtn: '⏹ Tugatish',
      nextBtn: '➡️ Keyingi savol',
      finishBtn: '✅ Sessiyani tugatish',
      retryBtn: '🔄 Qayta javob berish',
      repeatBtn: 'Qayta eshitish',
      speakBtn: '🎤 Gapirish',
      stopListenBtn: '⏹ To\'xtatish va Feedback olish',
      listening: 'Eshitilmoqda... Gapiring!',
      pressToSpeak: 'Mikrofon tugmasini bosing va gapiring',
      aiAnalyzing: 'AI javobingizni tahlil qilmoqda...',
      yourAnswer: 'Sizning javobingiz',
      aiExaminer: 'AI Examiner',
      speaking: '🔊 Gapirmoqda...',
      feedbackTitle: '📝 AI Feedback',
      score: 'Ball',
      improvedVersion: '✨ Improved Version (Band 7-8)',
      sessionEnded: '🏆 Sessiya tugadi!',
      answeredAll: 'ta savolga javob berdingiz. Ajoyib!',
      chooseTopic: 'Boshqa topic tanlash',
      sessionResults: '📋 Sessiya natijalari',
      previousQuestions: '📋 Oldingi savollar',
      part2prep: '📝 Tayyorgarlik vaqti',
      part2speak: '🎤 Gapirish vaqti',
      part2prepNote: "Notalaringizni yozing. Tayyor bo'lgach taymer boshlanadi.",
      part2info: 'Part 2 — Taymer rejimi',
      part2min1: '1 daqiqa tayyorgarlik (notalar yozish)',
      part2min2: '2 daqiqa gapirish vaqti',
      part2auto: 'Taymer avtomatik o\'tadi',
      preparation: 'Tayyorgarlik',
      chromeTip: 'Chrome yoki Edge brauzer ishlating',
      micTip: 'Mikrofon ruxsatini bering',
      quietTip: 'Tinch muhitda bo\'ling',
      questionList: 'Savollar',
      back: '← Ortga',
      savedSession: 'Sessiya saqlandi!',
      avgScoreLabel: "O'rtacha ball",
      xpEarned: 'XP qazondingiz',
      streakLabel: 'Kunlik streak',
      continueBtn: 'Davom etish',
      fluency: 'Fluency',
      vocabulary: 'Vocabulary',
      grammar: 'Grammar',
      pronunciation: 'Pronunciation',
      yourAnswerLabel: 'Sizning javobingiz',
      improvedLabel: 'Improved',
    },
    mockExam: {
      title: '🎓 Mock IELTS Speaking',
      subtitle: "To'liq imtihon simulyatsiyasi — random topiclar",
      startBtn: '🚀 Imtihonni boshlash',
      preparing: 'Savollar tayyorlanmoqda...',
      randomNote: '🎲 Har safar random topiclar tanlanadi — haqiqiy imtihon kabi',
      weeklyLimit: 'Haftalik limit tugadi',
      getPremium: '👑 Premium ko\'rish',
      partBreak: 'tugadi!',
      starting: 'boshlanmoqda...',
      topic: 'Mavzu',
      cancelBtn: '⏹ Imtihonni tugatish',
      cancelConfirm: 'Imtihonni yarim yo\'lda tugatmoqchimisiz? Natija saqlanmaydi.',
      resultTitle: 'Imtihon tugadi!',
      bandScore: 'Sizning IELTS Band Score:',
      retake: '🔄 Qayta topshirish',
      toDashboard: 'Dashboard →',
      analyzeMsg: 'AI tahlil qilmoqda...',
      retry: '🔄 Qayta',
      next: '➡️ Keyingi savol',
      finishPart: 'ga o\'tish',
      finishExam: '🏁 Imtihonni yakunlash',
      history: 'Oldingi imtihonlar',
      noHistory: 'Hali mock exam yo\'q. Birinchisini boshlang!',
      xpEarned: 'XP qazondingiz',
    },
    progress: {
      title: 'Haftalik progress',
      goalTitle: '🎯 Maqsad Band Score',
      change: 'O\'zgartirish',
      cancel: 'Bekor qilish',
      highGoal: '🌟 Yuqori maqsad! Ko\'p mashq kerak bo\'ladi',
      realisticGoal: '✅ Realistik maqsad!',
      startGoal: 'Boshlang\'ich maqsad, keyin oshirishingiz mumkin',
      currentScore: 'Hozirgi ball',
      goalReached: '✅ Maqsadga yetdingiz!',
      remaining: 'qoldi',
      consistency: 'Muntazamlik',
      weeklySessions: 'Haftalik sessiya',
      forecast: '🔮 Bashorat',
      forecastNote: 'Realistic = hozirgi sur\'atda · Optimal = har kuni mashq qilinsa',
      goalTarget: 'Maqsad',
      realistic: 'Realistic',
      optimal: 'Optimal',
      goalReachedLabel: '🎯 Maqsad!',
      tip: '💡 Tavsiya',
      lastSession: 'Oxirgi mashqdan',
      daysAgo: 'kun o\'tdi',
      totalSessions: 'ta sessiya tahlil qilindi',
      needMore: 'Grafik uchun kamida 3 ta sessiya kerak.',
      goalSaved: 'Maqsad yuqorida saqlandi.',
      targetLine: 'Maqsad',
    },
    premium: {
      title: 'Premium',
      subtitle: 'Cheksiz mashq qiling — maqsadingizga tezroq yeting',
      activeTitle: 'Siz Premium foydalanuvchisiz!',
      daysLeft: 'kun qoldi',
      allOpen: 'Barcha imkoniyatlar ochiq ✓',
      backDashboard: 'Dashboardga qaytish',
      feature: 'Imkoniyat',
      free: 'Bepul',
      popular: 'Mashhur',
      selectedPlan: 'Tanlangan reja',
      howToPay: 'Qanday to\'lash:',
      step1: '1. Telegram tugmasini bosing',
      step2: '2. Tanlangan rejangizni va ID ingizni yuboring',
      step3: '3. To\'lovni amalga oshiring',
      step4: '4. Admin 24 soat ichida Premium beradi',
      yourId: 'Sizning User ID (adminga yuboring):',
      copy: 'Nusxa',
      copied: '✓',
      telegramBtn: 'Telegramga yozish',
      note: "To'lovdan so'ng 24 soat ichida access beriladi",
      back: '← Ortga',
      sum: 'so\'m',
    },
    // Vocabulary
    vocab: {
      title: '📚 Topic Vocabulary',
      placeholder: 'Topic kiriting... (masalan: Technology, Education, Travel)',
      searchBtn: '🔍 Qidirish',
      searching: '⏳ Qidirilmoqda...',
      resultsFor: 'uchun topilgan so\'zlar',
      definition: 'Ta\'rif',
      example: 'Misol',
      error: 'Vocabulary olishda xatolik yuz berdi. Qayta urinib ko\'ring.',
      limitError: 'Kunlik limit tugadi! Vocabulary uchun kuniga 7 ta. Ertaga qayta urinib ko\'ring.',
    },
    // Common
    common: {
      loading: 'Yuklanmoqda...',
      back: '← Ortga',
      question: 'Savol',
      answer: 'Javob',
    },
  },
};
export default uz;